import classes from "./privacyPolicy.module.css";
import useSubmitPrivacyPolicy from "../functions/useSubmitPivacyPolicy";
import { Link } from "react-router-dom";
import { useRef, useState } from "react";
function PrivacyPolicy() {
  const [check, setCheck] = useState();

  const setterFunc = useSubmitPrivacyPolicy();
  const checkInput = useRef();

  const handlePrivacySubmission = (e) => {
    const checkedVal = e.target.checked;
    setterFunc(checkedVal);
  };
  const handlePrivacyByLink = () => {
    checkInput.current.checked = true;
    setterFunc(true);
  };
  return (
    <div className={classes.privacy_policy_check}>
      <div>
        <span
          className={`${classes.block} ${classes.required} ${classes.label}`}
        >
          個人情報の取り扱いについての同意
        </span>
      </div>
      <div>
        <input
          id="privacy-policy"
          type="checkbox"
          className={classes.privacyInput}
          onChange={handlePrivacySubmission}
          name="privacy-policy"
          ref={checkInput}
        />
        <Link
          to={
            "https://sky7mobile-shinplan.com/wp-content/uploads/2025/09/個人情報取り扱いについて.pdf"
          }
          target="_blank"
          htmlFor="privacy-policy"
          onClick={handlePrivacyByLink}
        >
          個人情報の取り扱いについての同意
        </Link>
      </div>
    </div>
  );
}
export default PrivacyPolicy;
